/**
 * messageHubUtils.js
 * Utility functions for message hub operations
 */

import {messageType} from './uiconstants';

/**
 * Emits a document open event to the message hub
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {Object} document - The document object to emit
 * @param {string} url - The URL associated with the document
 */
export const emitDocumentOpenEvent = (emit, document, url) => {
	// console.log('[messageHub:open] emitDocumentOpenEvent', {document, url}, new Error().stack);
	emit(messageType.open, {document, url});
};

/**
 * Emits a DaaS co-edit status change so the host app can record the document in Recent Documents.
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {Object} document - The document object (must include id, documentName, fileExt, documentTypeId, sourceEngagementId, contentURI)
 * @param {number} documentStatusId - The new DaaS document status id (e.g. DaaSCheckoutInProgress or DaaSCheckinInProgress)
 */
export const emitDaasStatusChangedEvent = (emit, document, documentStatusId) => {
	emit(messageType.daasStatusChanged, {document, documentStatusId});
};

/**
 * Emits a success message event to the message hub
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {string} message - The success message to display
 * @param {number} [autoDismissInSeconds=2000] - Time in seconds before the message auto-dismisses (0 = no auto-dismiss)
 */
export const emitSuccessMessageEvent = (emit, message, autoDismissInSeconds = 2000) => {
	emit(messageType.successMessage, {message, autoDismissInSeconds});
};

/**
 * Emits an error message event to the message hub
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {{message: String}} error - The error message or Error object to display
 */
export const emitErrorMessageEvent = (emit, error) => {
	emit(messageType.error, {error: error});
};

export const emitInfoMessageEvent = (emit, message, autoDismissInSeconds = 2000) => {
	emit(messageType.infoMessage, {message, autoDismissInSeconds});
};

/**
 * Emits a warning message event to the message hub
 * @param {Function} emit - The emit function from useMessageHubEmit
 * @param {string} message - The warning message to display
 * @param {number} [autoDismissInSeconds=2000] - Time in seconds before the message auto-dismisses (0 = no auto-dismiss)
 */
export const emitWarningMessageEvent = (emit, message, autoDismissInSeconds = 2000) => {
	emit(messageType.warningMessage, {message, autoDismissInSeconds});
};
